module.exports = __webpack_public_path__ + "static/media/letter.88bfbda0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/letter.svg
// module id = 747
// module chunks = 0